import React, { useEffect, useState } from 'react'
import CreateTag from './createTag'

function EditTags() {
  const [itemData, setItemData] = useState(null)

  useEffect(() => {
    const url = window.location.href
    const paramsStartIndex = url.indexOf('?')
    if (paramsStartIndex !== -1) {
      const paramString = url.slice(paramsStartIndex + 1)
      const paramsArray = paramString.split('&')
      const itemParam = paramsArray.find(param => param.startsWith('item='))
      if (itemParam) {
        try {
          const decodedItemParam = decodeURIComponent(itemParam.split('=')[1])
          const itemObject = JSON.parse(decodedItemParam)
          setItemData(itemObject)
        } catch (error) {
          console.error('Error parsing item data:', error)
        }
      }
    }
  }, [])

  console.log(itemData, 'itemitemitemitem')

  return (
    <div>
      {' '}
      <CreateTag serviceType={'editTag'} URLObject={itemData} />{' '}
    </div>
  )
}

export default EditTags
